import React, { useState, useContext } from "react";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import { CODE_SEPARATOR, isCodeError, isCodeWarning, STATE_COL_SUFFIX } from "../../dto";
import { Checkbox, ClickAwayListener, Fade, IconButton, Paper, Popper, Typography } from "@mui/material";
import CallMadeIcon from "@mui/icons-material/CallMade";
import { createCellId, createCellStateKey, translateCellStateMessage } from "../../Utils";
import { StoreContext } from "../../StoreContext";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
export const DefaultCellFormatter = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { style: { color: "var(--clr-primary)" } }, props.value),
        React.createElement(CellState, Object.assign({}, props))));
};
export const FloatCellFormatter = (props) => {
    let value = props.value != null ? props.value.toLocaleString() : "";
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { style: { color: "var(--clr-primary)" } }, value),
        React.createElement(CellState, Object.assign({}, props))));
};
export const BooleanCellRenderer = (props) => {
    const isTrue = (value) => {
        if (!value) {
            return false;
        }
        return value == true || value == 1;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Checkbox, { checked: isTrue(props.value), value: "", onChange: (event) => {
                let colId = props.colDef.field;
                props.node.setDataValue(colId, !isTrue(props.value));
            } }),
        React.createElement(CellState, Object.assign({}, props))));
};
export const ForeignKeyCellRenderer = (props) => {
    const handleClick = () => {
        props.onFKActionClicked(props.colDef.field, props.data);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { style: { color: "var(--clr-primary)" } }, props.value),
        React.createElement(CellState, Object.assign({}, props)),
        React.createElement(IconButton, { onClick: (event) => {
                handleClick;
            } },
            React.createElement(CallMadeIcon, null))));
};
const CellState = observer((props) => {
    let stateCell = props.data[props.colDef.field + STATE_COL_SUFFIX];
    let stateCodes = stateCell ? stateCell.split(CODE_SEPARATOR) : [];
    let cellId = createCellId(props.colDef.field, props.rowIndex.toString());
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const context = useContext(StoreContext);
    const [t, i18next] = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    // FIXME necessary to reload after update?
    let test = context.rootStore.dataStore.cellStates.get(createCellStateKey(props.colDef.field, stateCodes[0]));
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen(!open);
    };
    function getTranslatedMessage() {
        var _a;
        let message = (_a = context.rootStore.dataStore.cellStates.get(createCellStateKey(props.colDef.field, stateCodes[0]))) === null || _a === void 0 ? void 0 : _a.message;
        if (message != undefined) {
            return React.createElement(Typography, null, translateCellStateMessage(t, message));
        }
        return React.createElement(React.Fragment, null);
    }
    const renderStateIcon = () => {
        if (isCodeError(stateCodes) || isCodeWarning(stateCodes)) {
            return (React.createElement(React.Fragment, null,
                React.createElement(IconButton, { onClick: handleClick, id: cellId, onFocus: () => context.rootStore.dataStore.loadCellState(props.colDef.field, stateCodes[0]) }, isCodeError(stateCodes) ? (React.createElement(ErrorIcon, { sx: { color: "var(--clr-red)" } })) : isCodeWarning(stateCodes) ? (React.createElement(WarningIcon, { sx: { color: "var(--clr-yellow)" } })) : null),
                React.createElement(Popper, { anchorEl: anchorEl, open: open, transition: true }, ({ TransitionProps }) => (React.createElement(Fade, Object.assign({}, TransitionProps, { timeout: 350 }),
                    React.createElement("div", null,
                        React.createElement(ClickAwayListener, { onClickAway: () => {
                                setOpen(false);
                            } },
                            React.createElement(Paper, { sx: { p: 2 } }, getTranslatedMessage()))))))));
        }
        return React.createElement(React.Fragment, null);
    };
    return React.createElement(React.Fragment, null, stateCodes ? renderStateIcon() : null);
});
